import { Component, EventEmitter, State, Event, Prop, h } from '@stencil/core';

@Component({
  tag: 'legrandav-accordion',
  styleUrl: 'legrandav-accordion.css',
  shadow: true,
})
export class LegrandavAccordion {
  @State() toggle: boolean = false;

  @Event() onToggle: EventEmitter;

  @Prop() label: string;

  @Prop() description: string;

  @Prop() width: string;

  @Prop() color: string;

  toggleComponent() {
    this.toggle = !this.toggle;
    this.onToggle.emit({ visible: this.toggle });
  }

  render() {
    return (
      <div>
        <button
          class="accordion"
          style={{
            width: this.width,
            backgroundColor: this.color,
          }}
          onClick={() => this.toggleComponent()}
        >
          {this.label}
          {this.toggle ? (
            <svg transform="rotate(180)" width="14px" height="18px" viewBox="0 0 14 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect width="14" height="18"></rect>
                <path
                  d="M12.0187784,5.32138771 C12.4774933,4.88750173 13.2066434,4.89370691 13.6575897,5.33533425 C14.108536,5.77696159 14.1148721,6.49104363 13.6718306,6.94027894 L7.82652606,12.6647882 C7.37000795,13.1117373 6.62999205,13.1117373 6.17347394,12.6647882 L0.328169447,6.94027894 C-0.114872145,6.49104363 -0.108536027,5.77696159 0.342410275,5.33533425 C0.793356576,4.89370691 1.52250674,4.88750173 1.98122156,5.32138771 L7,10.2364514 L12.0187784,5.32138771 Z"
                  id="🎨-Icon-Style"
                  fill="#1B2D3A"
                ></path>
              </g>
            </svg>
          ) : (
            <svg aria-hidden="true" id="feedback-accordion-svg" width="14" height="18" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fill-rule="evenodd">
                <rect width="14" height="18"></rect>
                <path
                  d="M12.0187784,5.32138771 C12.4774933,4.88750173 13.2066434,4.89370691 13.6575897,5.33533425 C14.108536,5.77696159 14.1148721,6.49104363 13.6718306,6.94027894 L7.82652606,12.6647882 C7.37000795,13.1117373 6.62999205,13.1117373 6.17347394,12.6647882 L0.328169447,6.94027894 C-0.114872145,6.49104363 -0.108536027,5.77696159 0.342410275,5.33533425 C0.793356576,4.89370691 1.52250674,4.88750173 1.98122156,5.32138771 L7,10.2364514 L12.0187784,5.32138771 Z"
                  fill="#1b2d3a"
                ></path>
              </g>
            </svg>
          )}
        </button>
        <div class={`content-box ${this.toggle ? 'open' : 'close'}`} style={{ width: this.width }}>
          <p>{this.description}</p>
        </div>
      </div>
    );
  }
}
